import styled from 'styled-components';
import { Button } from 'ui/button';
import { Divider } from 'ui/divider';
import { body1, caption, colors, heading4, spacing } from 'ui/theme';

// For DestinationSelectorModal
export const TargetContentContainer = styled.div`
  display: flex;
  gap: ${spacing.half};
  align-items: center;
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const HeaderText = styled.div`
  ${body1}
`;

export const BodyText = styled.div`
  ${caption}
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin: ${spacing.base};
`;

export const StyledButton = styled(Button)`
  max-width: ${spacing.x10};
  height: ${spacing.x3};
`;

export const Header = styled.div`
  ${heading4}
  padding: ${spacing.base} ${spacing.double} 0;
`;

export const StyledDivider = styled(Divider)`
  margin: 0;
`;

export const ErrorCaption = styled.div`
  ${caption};
  color: ${colors.red100};
  margin-left: ${spacing.half};

  display: flex;
  align-items: center;
  gap: ${spacing.eighth};
`;
